import { IconCalendar } from '@tabler/icons-react';
import React from 'react';
import { Calendar } from 'react-date-range';
import SpinnerGetData from '../../components/common/SpinnerGetData';
import { getTipeLabel } from '../LaporanCashflow';

const LaporanCashflowKasir = ({
  laporanHarian,
  loadingLaporanHarian,
  numberWithCommas,
  roundNumber,
  trxLuar,
  tglFilter,
  handleSelect,
}) => {
  return (
    <div className="rounded-md">
      <div className="bg-white p-5 rounded-md border border-black print:border print:rounded-none print:p-4">
        <div className="mb-6 flex justify-between items-center">
          <div className="font-normal text-lg">
            Tanggal {laporanHarian.tanggal} {!tglFilter === null && tglFilter}
          </div>
          <div>
            <div className="dropdown dropdown-end">
              <label
                tabIndex={0}
                className="bg-orange-500 p-2  flex items-center text-white hover:bg-orange-600 rounded-md cursor-pointer"
              >
                <IconCalendar />
              </label>
              <div tabIndex={0} className="dropdown-content menu p-2 shadow bg-base-100 rounded-box -left-72 w-52">
                <Calendar date={new Date()} onChange={handleSelect} />
              </div>
            </div>
          </div>
        </div>
        {loadingLaporanHarian ? (
          <SpinnerGetData />
        ) : (
          <>
            {laporanHarian === undefined ? (
              <div></div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full border border-black text-sm print:text-[11px]">
                  <tbody>
                    {/* KAS */}
                    <tr className="border-b border-black">
                      <td className="w-1/3 border-r border-black font-semibold px-3 py-2 align-top text-md md:text-lg">
                        KAS
                      </td>
                      <td className="px-3 py-2 align-top">
                        <span className="font-normal text-lg">
                          Rp. {numberWithCommas(laporanHarian.kas)}
                        </span>
                      </td>
                    </tr>

                    {/* PEMBELIAN */}
                    <tr className="border-b border-black align-top">
                      <td className="w-1/3 border-r border-black font-semibold px-3 py-2 text-md md:text-lg">
                        PEMBELIAN
                      </td>
                      <td className="px-3 py-2">
                        {laporanHarian.pembelian?.total_harga === 0 ? (
                          <div>Data Kosong</div>
                        ) : (
                          <>
                            <div className="font-normal text-lg mb-2">
                              Rp. {numberWithCommas(laporanHarian?.pembelian?.total_harga)} /{' '}
                              {roundNumber(laporanHarian?.pembelian?.total_berat)} gram / Rp.{' '}
                              {numberWithCommas(Math.round(laporanHarian?.pembelian?.rata_rata))}
                            </div>
                            {laporanHarian.pembelian?.items !== undefined && (
                              <div className="space-y-1">
                                {laporanHarian.pembelian?.items?.map((itp, i) => (
                                  <div key={i} className="text-sm">
                                    <span className="text-red-500 font-bold">*</span> {itp.karat} karat :{' '}
                                    {itp.total_berat} gram / Rp.
                                    {numberWithCommas(itp.total_harga)} / Rp.
                                    {numberWithCommas(Math.round(itp.rata_rata))}
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* PENJUALAN */}
                    <tr className="border-b border-black align-top">
                      <td className="w-1/3 border-r border-black font-semibold px-3 py-2 text-md md:text-lg">
                        PENJUALAN
                      </td>
                      <td className="px-3 py-2">
                        {laporanHarian.penjualan?.total_harga === 0 ? (
                          <div>Data Kosong</div>
                        ) : (
                          <>
                            <div className="font-normal text-lg mb-2">
                              Rp. {numberWithCommas(laporanHarian?.penjualan?.total_harga)} /{' '}
                              {laporanHarian?.penjualan?.total_berat} gram / Rp.{' '}
                              {numberWithCommas(Math.round(laporanHarian?.penjualan?.rata_rata))}
                            </div>
                            {laporanHarian.penjualan?.items !== undefined && (
                              <div className="space-y-1">
                                {laporanHarian.penjualan?.items?.map((itp, i) => (
                                  <div key={i} className="text-sm">
                                    <span className="font-bold">*</span> {itp.karat} karat : {itp.total_item} pcs /{' '}
                                    {itp.total_berat} gr / Rp.
                                    {numberWithCommas(itp.total_harga)} / Rata-rata.{' '}
                                    {numberWithCommas(Math.round(itp.rata_rata, 1))}
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>

                    {/* LUAR TRANSAKSI */}
                    <tr className="border-b border-black align-top">
                      <td className="w-1/3 border-r border-black font-semibold px-3 py-2 text-md md:text-lg">
                        LUAR TRANSAKSI
                        <div className="text-sm font-normal">PENGELUARAN &amp; PEMASUKAN</div>
                      </td>
                      <td className="px-3 py-2">
                        <div className="mt-1 text-sm space-y-1">
                          {trxLuar.length === 0 ? (
                            <div className="italic text-gray-400">Tidak ada pengeluaran / pemasukan luar transaksi</div>
                          ) : (
                            trxLuar.map((res, i) => {
                              const tipePengeluaran = getTipeLabel(res.tipe) || res.title || 'Pengeluaran';
                              const rawKeterangan =
                                res.keterangan &&
                                res.keterangan.trim() !== '' &&
                                res.keterangan.trim() !== '-' &&
                                res.keterangan.trim() !== '.' &&
                                res.keterangan.trim().toLowerCase() !== tipePengeluaran.toLowerCase()
                                  ? res.keterangan.trim()
                                  : res.title &&
                                    res.title !== '-' &&
                                    res.title.trim().toLowerCase() !== tipePengeluaran.toLowerCase()
                                  ? res.title.trim()
                                  : '';

                              return (
                                <div key={i} className="flex items-center gap-1.5 flex-wrap">
                                  <span className="font-bold text-gray-500">-</span>
                                  <span className="font-semibold">{tipePengeluaran}</span>
                                  <span className="text-gray-400">/</span>
                                  <span className="font-semibold">Rp. {numberWithCommas(res.nominal)}</span>
                                  {rawKeterangan && (
                                    <>
                                      <span className="text-gray-400">-</span>
                                      <span className="text-gray-600 dark:text-gray-300 italic">{rawKeterangan}</span>
                                    </>
                                  )}
                                </div>
                              );
                            })
                          )}
                        </div>
                      </td>
                    </tr>

                    {/* SISA KAS */}
                    <tr className="align-top">
                      <td className="w-1/3 border-r border-black font-semibold px-3 py-2 text-md md:text-lg">
                        SISA KAS
                      </td>
                      <td className="px-3 py-2">
                        <span className="font-normal text-lg">
                          Rp. {numberWithCommas(laporanHarian.sisa_kas)}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default LaporanCashflowKasir;